import { useEffect, type JSX } from 'react';

import { ProviderAbout } from './provider/about.js';
import { CareCoordination } from './provider/care-coordination.js';
import { ConditionsGrid } from './provider/conditions.js';
import { CtaBand } from './provider/cta-band.js';
import { ProviderFaq } from './provider/faq.js';
import { ProviderFooter } from './provider/footer.js';
import { ProviderHero } from './provider/hero.js';
import { HowItWorks } from './provider/how-it-works.js';
import styles from './provider/styles.module.css';
import { ProviderTopbar } from './provider/topbar.js';

/**
 * ProviderLandingPage — `/provider` route.
 *
 * Owns its own chrome (topbar + section navbar) — rendered outside AppShell
 * so the language toggle header is not shown (provider page is English-only).
 *
 * AC-1: Provider landing page at /provider with program overview,
 * ACCESS model context, referral process, and CTA to /refer.
 */
export function ProviderLandingPage(): JSX.Element {
  // Scoped smooth scrolling — applied to <html> only while this page is mounted.
  useEffect(() => {
    const html = document.documentElement;
    html.style.scrollBehavior = 'smooth';
    return () => {
      html.style.removeProperty('scroll-behavior');
    };
  }, []);

  return (
    <main className={styles.page}>
      <ProviderTopbar />
      <nav className={styles.navbar} aria-label="Section navigation">
        <div className={styles.navbarRow}>
          <a href="#about">About the Program</a>
          <a href="#how">How Referrals Work</a>
          <a href="#coordination">Care Coordination</a>
          <a href="#conditions">Who Qualifies</a>
          <a href="#faqs">FAQs</a>
        </div>
      </nav>
      <ProviderHero />
      <ProviderAbout />
      <HowItWorks />
      <CareCoordination />
      <ConditionsGrid />
      <CtaBand />
      <ProviderFaq />
      <ProviderFooter />
    </main>
  );
}

export default ProviderLandingPage;
